import axios from 'axios'
import { tenantName } from '../helpers/helpers'

export const API_PREFIX = 'v1'
export const token = process.env.VUE_APP_API_TOKEN

const apiUrl = `https://${tenantName}.${process.env.VUE_APP_API_BASE_URL}/api/`

const http = axios.create({

  baseURL: apiUrl,
  headers: {
    Authorization: token ? `Bearer ${token}` : ''
  }
})

export default (http)
